import React from 'react';
import '../styles/Research.css'; // reuse styles from Research.css

function AboutUs() {
  return (
    <div className="research-page">
      <div className="container">
        <section className="research-category">
          <h2>Our Mission</h2>
          <p>
            We are a consulting, research and education company. Our overarching mission is to enable 
            user-friendly analysis of the response of materials and structural components with different 
            microstructural details that target specific, user-defined criteria.
          </p>
          <p>
            The goal is both to facilitate generation of designs with targeted performance, and to help 
            engineers, researchers and students understand the relationship between underpinning 
            microstructure and material/structural component performance. We accomplish these goals 
            through the development of accurate, efficient, and easy-to-use computational algorithms 
            based on our own in-house concepts that are at least as competitive as the standard 
            variational-based commercial packages.
          </p>
        </section>
      </div>
    </div>
  );
}

export default AboutUs;
